import {Component, Input, OnInit} from '@angular/core';
import {LocationService} from "../../../../../shared/services/location.service";
import {AllLocationResponse, AllLocationResponsePagination} from "../../../../../shared/models/location.types";
import {Router} from "@angular/router";
import {PageEvent} from "@angular/material/paginator";
import {MatDialog} from "@angular/material/dialog";


@Component({
    selector: 'app-location',
    templateUrl: './location.component.html'
})
export class LocationComponent implements OnInit {
    @Input() openAsDialog = false;
    allLocations: AllLocationResponse[] = [];
    locationName = '';
    allLocationPageable: AllLocationResponsePagination;
    pageNumber = 0;
    failedLogoIds = new Set<string>();

    constructor(private locationService: LocationService,
                private router: Router,
                private matDialog: MatDialog) {
    }

    ngOnInit(): void {
        this.searchLocation();
    }

    setLocation(location: AllLocationResponse) {
        this.locationService.currentLocationDetail = location;
        if (this.openAsDialog) {
            this.closeDialog();
        }
        if (this.router.url === "/dashboard/select-location") {
            this.router.navigate(['dashboard']).then(() => {
                window.location.reload();
            });
        }
    }

    searchLocation() {
        this.locationService.fetchAllLocationForOrgUserV2(this.locationName, this.pageNumber).subscribe({
            next: (res) => {
                this.allLocationPageable = res;
                this.allLocations = res.locationListResList;
                if (!this.openAsDialog && !res.totalElements) {
                    this.router.navigate(['/dashboard/quick-setup']);
                }
            }
        });
    }

    clearSearchText() {
        this.locationName = '';
        this.searchLocation();
    }

    getNextLocations($event: PageEvent) {
        this.pageNumber = $event.pageIndex;
        this.searchLocation();
    }

    closeDialog() {
        this.matDialog.closeAll();
    }

    hasLocationLogo(location: AllLocationResponse): boolean {
        return !!location.logoURL?.trim() && !this.failedLogoIds.has(location.locationId);
    }

    onLogoError(locationId: string): void {
        this.failedLogoIds.add(locationId);
    }

    getLocationInitial(location: AllLocationResponse): string {
        return location.name?.trim()?.[0]?.toUpperCase() || '?';
    }
}
